var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleUpRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256C496 123.42 388.58 16 256 16S16 123.42 16 256C16 388.582 123.42 496 256 496S496 388.582 496 256ZM352.631 338.665C346.653 341.151 339.77 339.77 335.196 335.196L289.941 289.941L222.059 357.823C209.562 370.32 189.301 370.32 176.804 357.823L154.177 335.196C141.68 322.699 141.68 302.438 154.177 289.941L222.059 222.059L176.804 176.804C172.23 172.23 170.849 165.347 173.335 159.369C175.81 153.381 181.643 149.492 188.118 149.492H346.51C355.345 149.492 362.508 156.655 362.508 165.49V323.882C362.508 330.357 358.619 336.19 352.631 338.665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUpRight);
export default __webpack_public_path__ + "static/media/circle-up-right.ff39f42ed2ae0894c07f5e6a69bbd747.svg";
export { ForwardRef as ReactComponent };